import { Formatter } from '../../Shared/utils/formatter';

export function dateOfGiftForDisplay(giftDate: Date): string {
	return Formatter.formatDate(giftDate, 'MMM D, YYYY');
}
